import { defineMessages } from '@formatjs/intl';

export const messages = defineMessages({
	heading: {
		id: 'homepage.blogFeed.heading2',
		defaultMessage: 'Check out our blog for more meditation, sleep, stress, and mental health resources.',
		description: 'Heading for the blog feed section',
	},
});
